import styled from 'styled-components';

export const OrderCardContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const OrderInfo = styled.div`
  flex: 1;
  
  h3 {
    margin: 0 0 8px 0;
    color: #333;
    font-size: 18px;
  }
  
  p {
    margin: 4px 0;
    color: #666;
    font-size: 14px;
  }
`;

export const OrderButton = styled.button`
  background: #c71618;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.2s;
  
  &:hover {
    background: #a01214;
  }
  
  span {
    font-size: 18px;
  }
`;
